import PropTypes from 'prop-types'

import { routeFor } from '@/utils/router'
import { translate } from '@/utils/translations'

const Chapter = ({ id, title }) => {
  return (
    <div
      className='chapter row'
      id={`chapter-${id}`}
    >
      <div className='chapter__title'>
        {title}
      </div>
      <div className='u-align--right'>
        <a
          className='chapter__title-link u-flush--bottom'
          href={routeFor('asset', { id })}
        >
          {translate('purchase.view')}
        </a>
      </div>
    </div>
  )
}

export default Chapter

Chapter.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired
}
